import MediaQuery from 'react-responsive';

import MarketsTableLoadingSkeleton from 'components/markets/partials/MarketsTableLoadingSkeleton';
import { device } from 'helpers/screenSizes';
import TableSkeleton from 'UIKit/TableSkeleton/TableSkeleton';

const DynamicLoader = ({ desktopVariant }) => (
  <MediaQuery query={device.up.md}>
    {matches =>
      matches ? (
        <MarketsTableLoadingSkeleton variant={desktopVariant} />
      ) : (
        <TableSkeleton num={9} />
      )
    }
  </MediaQuery>
);

export default DynamicLoader;
